module.exports = __webpack_public_path__ + "img/logo-internal.abbea379.svg";